export const NUMBER_THEN_STREET = 'NUMBER_THEN_STREET';
export const STREET_THEN_NUMBER = 'STREET_THEN_NUMBER';
